<script>
  import ImageProc from "./ImageProc";
  import { onMount } from "svelte";

  export let capture;
  let video;
  let noiseVideo;
  let tracks;
  let canvas;
  let canvasContext;
  let rawCanvas;
  let rawCanvasContext;
  let noiseCanvas;
  let noiseCanvasContext;
  const initCamera = (stream) => {
    const MAX_VIDEO_WIDTH = 800;
    const videoWidth =
      window.parent.screen.width > MAX_VIDEO_WIDTH
        ? MAX_VIDEO_WIDTH
        : window.parent.screen.width;
    video = document.getElementById("video");
    video.width = videoWidth;
    video.srcObject = stream;
    video.play();
    noiseVideo = document.getElementById("noiseVideo");

    canvas = document.getElementById("canvas");
    canvasContext = canvas.getContext("2d");
    rawCanvas = document.getElementById("rawCanvas");
    rawCanvasContext = rawCanvas.getContext("2d");
    noiseCanvas = document.getElementById("noiseCanvas");
    noiseCanvasContext = noiseCanvas.getContext("2d");

    const waitId = setInterval(() => {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      rawCanvas.width = video.videoWidth;
      rawCanvas.height = video.videoHeight;
      noiseCanvas.width = video.videoWidth;
      noiseCanvas.height = video.videoHeight;
      if (canvas.width > 0) {
        noiseVideo.play();
        updateCanvas();
        clearInterval(waitId);
      }
    }, 100);
  };

  const updateCanvas = () => {
    rawCanvasContext.drawImage(
      video,
      0,
      0,
      video.videoWidth,
      video.videoHeight
    );
    noiseCanvasContext.drawImage(
      noiseVideo,
      0,
      0,
      video.videoWidth,
      video.videoHeight
    );

    ImageProc.grayAndMulti(
      rawCanvasContext,
      noiseCanvasContext,
      canvasContext,
      rawCanvas.width,
      rawCanvas.height
    );
    requestAnimationFrame(updateCanvas);
  };

  const initialize = () => {
    navigator.mediaDevices
      .getUserMedia({
        audio: false,
        video: { facingMode: "environment" },
      })
      .then((stream) => {
        tracks = stream.getTracks();
        initCamera(stream);
      })
      .catch((err) => {
        window.alert(
          "カメラの起動に失敗しました。カメラが使用可能な状態であることを確認してください。"
        );
        throw err;
      });
  };

  const preCapture = () => {
    const image = canvas.toDataURL();
    if (tracks) {
      tracks.forEach((track) => {
        track.stop();
      });
      video.srcObject = null;
      canvas.height = 0;
      canvas.width = 0;
      canvas.remove();
      rawCanvas.height = 0;
      rawCanvas.width = 0;
      rawCanvas.remove();
      noiseCanvas.height = 0;
      noiseCanvas.width = 0;
      noiseCanvas.remove();
    }

    capture(image);
  };

  onMount(async () => {
    initialize();
  });
</script>

<div class="capture">
  <!-- svelte-ignore a11y-media-has-caption -->
  <video id="video" class="hidden" autoplay playsinline />
  <!-- svelte-ignore a11y-media-has-caption -->
  <video id="noiseVideo" src="./noise.mp4" class="hidden" playsinline loop />
  <canvas id="canvas" />
  <canvas id="rawCanvas" class="hidden" />
  <canvas id="noiseCanvas" class="hidden" />
</div>
<div class="controller">
  <button class="button-primary" on:click={preCapture}> 撮影 </button>
</div>

<style>
  .capture {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: rgb(7, 7, 7);
  }

  .hidden {
    display: none;
  }

  #canvas {
    width: 100%;
    max-width: 800px;
  }

  .controller {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 48px;
  }
  .controller > * {
    margin: 0 10px;
  }
</style>
